<template>
    <Popup :open="open" @open="this.$emit('update:open', (open = !open))" :padding="true">
        <div>
            <p>
                {{ $t('remove_account_modal_headline') }}
            </p>
            <strong class="my-2 block text-red">
                {{ $t('plain_pelase_note') }}:
                <span class="text-blue-dark font-body">
                    <p v-html="$t('remove_account_description')"></p>
                </span>
            </strong>

            <div class="flex flex-col xl:flex-row gap-4 mt-4">
                <FormButton type="submit" class="w-auto" styling="primary xs flex items-center gap-3 text-xs" @click="$emit('update:open', false)" :value="$t('plain_abort')">
                </FormButton>
                <FormButton type="submit" class="w-auto" styling="secondary !border-red flex items-center gap-3" @click="removeAccount()" :value="$t('remove_accoun_confirm')">
                </FormButton>
            </div>
        </div>
    </Popup>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../api';

export default {
    methods: {
        removeAccount() {
            api.delete(`/users/${this.get.id}`).then((response) => {
                location.reload();
            });
        }
    },

    props: ['open'],
    emits: ['update:open'],

    watch: {
        open: function () {
            this.$emit('update:open', this.open);
        }
    },

    computed: {
        ...mapGetters('user', ['get'])
    }
};
</script>
